export default __webpack_public_path__ + "static/media/EAST2470.34I-34275_-18526_0.2ef4e62c.jpg";